import { Injectable } from '@angular/core';
import { PakBomViewMode, PakLocationViewMode } from '@cpak/enums';

// Defines context for tracking events
// Is multi-instance, so in some cases should be provided in order to redefine context for scope
// For example when we open modal window on a page that has tracking context already provided
@Injectable()
export class TrackingContextService {
  public currentTab: string | null = null;

  public currentMode: PakBomViewMode | PakLocationViewMode | null = null;
}
